export enum TextAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center',
  Justify = 'justify',
}
